module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n    我的打卡记录\n    "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n      " + _vm._s(_vm.userName) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "46px"
    }
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_vm._v("\n          " + _vm._s(_vm.thisWeek) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.thisWeekLabel) + "     " + _vm._s(_vm._f("dateTypeFormatter")(_vm.dateType)) + "     ")])]), _vm._v(" "), _c('flexbox-item', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-search",
    attrs: {
      "type": "ios-search",
      "size": "30",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 512 512"
    },
    on: {
      "click": _vm.showPlugin
    }
  }, [_c('path', {
    attrs: {
      "d": "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z"
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "timeline-demo"
  }, [_c('timeline', _vm._l((_vm.attendanceRecordList), function(item, key) {
    return _c('timeline-item', {
      key: key
    }, [_c('h4', [_vm._v(_vm._s(_vm._f("signType")(item.signType)))]), _vm._v(" "), _c('p', [_vm._v("打卡时间：" + _vm._s(_vm._f("time")(item.signTime)))]), _vm._v(" "), _c('p', [_vm._v("打卡地点：" + _vm._s(item.areaName))]), _vm._v(" "), _c('p', [_vm._v("打卡来源：" + _vm._s(_vm._f("source")(item.source_from)))])])
  }))], 1), _vm._v(" "), (_vm.nodata) ? _c('div', {
    staticClass: "nodata"
  }, [_vm._v("暂无数据")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29bb80d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Attendance-count.vue
// module id = 3cm/
// module chunks = 0